// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"482":"cbaa57b3","635":"7795cd54","682":"46e11b09"}[chunkId] + ".chunk.css";
};